import React from "react";

const MarqueeSection = () => {
  return (
    /* marquee/padding_zero-section start */
    <section className="prt-row padding_zero-section bg-base-gradient overflow-hidden clearfix">
      <div className="container-fluid">
        {/* row */}
        <div className="row">
          <div className="col-lg-12 p-0">
            <div className="marquee-block overflow-hidden">
              <div className="marquee">
                <div className="marquee-content">
                  <div className="marquee-text">Servicio Integral: Todas las tarifas incluyen el servicio de psicología y naturopatía.</div>
                  <div className="marquee-text" aria-hidden="true">Servicio Integral: Todas las tarifas incluyen el servicio de psicología y naturopatía.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* row end */}
      </div>
    </section>
    /* marquee/padding_zero-section end */
  );
};

export default MarqueeSection;
